import { WarningOutlined } from '@ant-design/icons';
import { Modal, ModalProps, Typography } from 'antd';
import { Trans, useTranslation } from 'react-i18next';

const ActiveCandidatesWarningModal = ({ ...props }: ModalProps) => {
  const { t } = useTranslation();

  return (
    <Modal
      title={
        <Typography.Text strong>
          <WarningOutlined /> <Trans>Atenção! Esta vaga será concluída automaticamente</Trans>
        </Typography.Text>
      }
      okText={t('Continuar')}
      okButtonProps={{ danger: true }}
      cancelText={t('Retornar e enviar feedback')}
      {...props}
    >
      <Typography.Paragraph>
        <Trans
          components={{
            strong: <Typography.Text strong />,
          }}
        >
          Ao realizar esta movimentação, você preencherá todas as posições e esta vaga será
          <strong> concluída automaticamente</strong>.
        </Trans>
      </Typography.Paragraph>
      <Typography.Paragraph>
        <Trans
          components={{
            strong: <Typography.Text strong />,
          }}
        >
          Antes de confirmar essa ação, lembre-se que após uma vaga ser concluída, não será mais
          possível
          <strong> Reprovar</strong> candidatos. Se ainda houver candidatos ativos no processo,{' '}
          recomendamos que realize a ação de <strong>Reprovar</strong>, enviando email de feedback,{' '}
          e então conclua a vaga movendo os candidatos selecionados para a etapa{' '}
          <strong>Contratados</strong> novamente.
        </Trans>
      </Typography.Paragraph>
    </Modal>
  );
};

export default ActiveCandidatesWarningModal;
